import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Icon,
  RowView,
  RowView2,
} from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import { useNavigate } from "react-router-dom";
import { LiveListItem } from "../../../../Component/Interface/Live";
import api from "../../../../Component/axios_Interceptor/api";
import url, { SERVER_ADDRESS } from "../../../../Component/server";

interface LiveListProps {
  liveList: LiveListItem[];
  isLive: boolean;
  search_live: (text: string) => void;
  search?: string;
  isLogin: boolean;
  follow?: string;
}

const LiveList = ({
  liveList,
  isLive,
  search_live,
  search,
  isLogin,
  follow,
}: LiveListProps) => {
  const Navigate = useNavigate();

  // 팔로우
  const store_follow = async (store_seq: number) => {
    try {
      const res = await api.post(url.Communication_url.store_follow, {
        store_seq: store_seq,
      });
    } catch (error) {
      console.log(error);
    } finally {
      search_live(search || "");
    }
  };

  const store_unfollow = async (store_seq: number) => {
    try {
      const res = await api.delete(url.Communication_url.store_unfollow, {
        data: {
          store_seq: store_seq,
        },
      });
    } catch (error) {
      console.log(error);
    } finally {
      search_live(search || "");
    }
  };

  const go_live = async (
    viewer_count: number,
    live_limit: number,
    seq: number
  ) => {
    if (viewer_count < Number(live_limit)) {
      const token = localStorage.getItem("key") || null;

      if (token) {
        Navigate(`/live/${seq}`, {
          state: { check: "check" },
        });
      } else {
        alert("로그인을 해주세요.");
      }
    } else {
      alert("시청 가능 인원이 초과되었습니다.");
    }
  };

  return (
    <LiveListDiv>
      {liveList.length > 0 &&
        liveList.map((item, index) => {
          return (
            <div key={index}>
              <Thimbnail
                style={{
                  backgroundImage: `url(${
                    item.live_img && item.live_img.trim() !== ""
                      ? SERVER_ADDRESS + "openfile/" + item.live_img
                      : require("../../../../Image/image_thimbnail_base.png")
                  })`,
                }}
                onClick={() => {
                  isLive &&
                    go_live(item.viewer_count, item.live_limit, item.seq);
                }}
              >
                <RowView2>
                  <Icon
                    src={
                      isLive
                        ? require("../../../../Image/ic_live_on.png")
                        : require("../../../../Image/ic_live_off.png")
                    }
                  />
                  {isLive && (
                    <ViewCount>
                      {amountFormat(item.viewer_count)}명 시청
                    </ViewCount>
                  )}
                </RowView2>
                <Title>{item.live_title}</Title>
              </Thimbnail>
              <StoreInfo>
                <ProfileDiv>
                  <ProfileImage
                    src={
                      item.store.profile_img === ""
                        ? require("../../../../Image/Logo.png")
                        : SERVER_ADDRESS + "openfile/" + item.store.profile_img
                    }
                  />
                  <Nickname>{item.store.store_name}</Nickname>
                </ProfileDiv>
                {isLogin && (
                  <Icon
                    className="btn"
                    src={
                      item.follow_yn === "y" || follow === "찜"
                        ? require("../../../../Image/ic_follow_off.png")
                        : require("../../../../Image/ic_follow_on.png")
                    }
                    onClick={() => {
                      item.follow_yn === "y" || follow === "찜"
                        ? store_unfollow(Number(item.store_seq))
                        : store_follow(Number(item.store_seq));
                    }}
                  />
                )}
              </StoreInfo>
            </div>
          );
        })}
    </LiveListDiv>
  );
};

export default LiveList;

const LiveListDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%); /* 2열로 배치 */
  gap: 16px;
  padding: 16px 0px;
  color: white;
  margin-right: 16px;
`;

const Thimbnail = styled.div`
  background-size: cover;
  background-position: center;
  width: 100%;
  aspect-ratio: 9/10; /* 일정한 비율 유지 */
  border-radius: 8px;
  box-sizing: border-box;
  padding: 8px;
  cursor: pointer;
`;

const ViewCount = styled.div`
  background-color: black;
  padding: 0px 6px;
  height: 20px;
  line-height: 20px; /* 높이와 동일하게 설정하여 수직 가운데 정렬 */
  border-radius: 4px;
  font-size: 12px;
  margin-left: 5px;
  display: inline-block; /* 한 줄 텍스트를 위한 설정 */
  overflow: hidden; /* 넘치는 텍스트 숨김 */
  text-overflow: ellipsis; /* 넘치는 텍스트를 ...으로 표시 */
  white-space: nowrap; /* 텍스트를 한 줄로 유지 */
  text-align: center; /* 수평 가운데 정렬 */
`;

const Title = styled.div`
  font-size: 16px;
  font-family: var(--font-Pretendard-Bold);
  margin-top: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const StoreInfo = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ProfileDiv = styled(RowView)`
  max-width: 100%;
  overflow: hidden;
  justify-content: flex-start;
`;

const Nickname = styled.div`
  max-width: 75%; /* 최대 너비 설정 */
  display: inline-block; /* 한 줄 텍스트를 위한 설정 */
  overflow: hidden; /* 넘치는 텍스트 숨김 */
  text-overflow: ellipsis; /* 넘치는 텍스트를 ...으로 표시 */
  white-space: nowrap; /* 텍스트를 한 줄로 유지 */
`;

const ProfileImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 100px;
  margin-right: 5px;
`;
